import { html } from 'lit';
import { ApexSlotableMixin } from '@fmr-pr103625/apex-slots';
import { deprecatePropertyTo, apexCustomElement, CommonContent } from '@fmr-pr103625/apex-core';
import { ApexValidatableBaseComponent } from '@fmr-pr103625/apex-validations';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i=(i,e)=>"method"===e.kind&&e.descriptor&&!("value"in e.descriptor)?{...e,finisher(n){n.createProperty(e.key,i);}}:{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){"function"==typeof e.initializer&&(this[e.key]=e.initializer.call(this));},finisher(n){n.createProperty(e.key,i);}},e=(i,e,n)=>{e.constructor.createProperty(n,i);};function n$1(n){return (t,o)=>void 0!==o?e(n,t,o):i(n,t)}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var n;null!=(null===(n=window.HTMLSlotElement)||void 0===n?void 0:n.prototype.assignedElements)?(o,n)=>o.assignedElements(n):(o,n)=>o.assignedNodes(n).filter((o=>o.nodeType===Node.ELEMENT_NODE));

var version = "3.9.0";

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".apex3-error-message.show-element{display:flex}.apex3-error-message.hide-element{display:none}.apex3-text-input{display:block}.apex3-error-message{margin:.5rem 0 0}[slot=inline-accessory-actions]{display:flex}.apex3-text-input-label{align-items:center;display:flex}.apex3-text-input-label>s-slot{display:inline-block}.apex3-text-input-label [slot=inline-readonly-accessory]{display:inline-block;margin-left:.5rem}.pvd-field-group__field-group>.apex3-text-input-actions{margin:1.5rem 0 0}@media (min-width:32em){.pvd-field-group__field-group>.apex3-text-input-actions{margin:0 0 0 1.5rem}}.pvd-field-group--dense .pvd-field-group__field-group>.apex3-text-input+.apex3-text-input,.pvd-field-group--dense .pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:1.5rem}.pvd-field-group--inline-always>.pvd-field-group__field-group>s-slot>s-assigned-wrapper{align-items:flex-start;display:flex;flex-flow:row nowrap}.pvd-field-group--inline-always>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-always>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-always>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input,.pvd-field-group--inline-always>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-always>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{flex:1 1 100%}.pvd-field-group--inline-always.pvd-field-group--vertical-align-center>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:center}.pvd-field-group--inline-always.pvd-field-group--vertical-align-bottom>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:flex-end}.pvd-field-group--inline-always>.apex3-text-input{align-items:flex-start;display:flex;flex:1 1 100%;flex-flow:row nowrap}.pvd-field-group--inline-always>.apex3-text-input>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-always>.apex3-text-input>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-always>.apex3-text-input>.apex3-text-input,.pvd-field-group--inline-always>.apex3-text-input>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-always.pvd-field-group--vertical-align-center>.apex3-text-input{align-items:center}.pvd-field-group--inline-always.pvd-field-group--vertical-align-bottom>.apex3-text-input{align-items:flex-end}@media (min-width:32em){.pvd-field-group--inline-at-512>.pvd-field-group__field-group>s-slot>s-assigned-wrapper{align-items:flex-start;display:flex;flex-flow:row nowrap}.pvd-field-group--inline-at-512>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-512>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-512>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input,.pvd-field-group--inline-at-512>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-512>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{flex:1 1 100%}.pvd-field-group--inline-at-512.pvd-field-group--vertical-align-center>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-512.pvd-field-group--vertical-align-bottom>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:flex-end}.pvd-field-group--inline-at-512>.apex3-text-input{align-items:flex-start;display:flex;flex:1 1 100%;flex-flow:row nowrap}.pvd-field-group--inline-at-512>.apex3-text-input>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-512>.apex3-text-input>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-512>.apex3-text-input>.apex3-text-input,.pvd-field-group--inline-at-512>.apex3-text-input>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-512.pvd-field-group--vertical-align-center>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-512.pvd-field-group--vertical-align-bottom>.apex3-text-input{align-items:flex-end}}@media (min-width:48em){.pvd-field-group--inline-at-768>.pvd-field-group__field-group>s-slot>s-assigned-wrapper{align-items:flex-start;display:flex;flex-flow:row nowrap}.pvd-field-group--inline-at-768>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-768>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-768>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input,.pvd-field-group--inline-at-768>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-768>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{flex:1 1 100%}.pvd-field-group--inline-at-768.pvd-field-group--vertical-align-center>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-768.pvd-field-group--vertical-align-bottom>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:flex-end}.pvd-field-group--inline-at-768>.apex3-text-input{align-items:flex-start;display:flex;flex:1 1 100%;flex-flow:row nowrap}.pvd-field-group--inline-at-768>.apex3-text-input>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-768>.apex3-text-input>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-768>.apex3-text-input>.apex3-text-input,.pvd-field-group--inline-at-768>.apex3-text-input>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-768.pvd-field-group--vertical-align-center>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-768.pvd-field-group--vertical-align-bottom>.apex3-text-input{align-items:flex-end}}@media (min-width:60em){.pvd-field-group--inline-at-960>.pvd-field-group__field-group>s-slot>s-assigned-wrapper{align-items:flex-start;display:flex;flex-flow:row nowrap}.pvd-field-group--inline-at-960>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-960>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-960>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input,.pvd-field-group--inline-at-960>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-960>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{flex:1 1 100%}.pvd-field-group--inline-at-960.pvd-field-group--vertical-align-center>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-960.pvd-field-group--vertical-align-bottom>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:flex-end}.pvd-field-group--inline-at-960>.apex3-text-input{align-items:flex-start;display:flex;flex:1 1 100%;flex-flow:row nowrap}.pvd-field-group--inline-at-960>.apex3-text-input>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-960>.apex3-text-input>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-960>.apex3-text-input>.apex3-text-input,.pvd-field-group--inline-at-960>.apex3-text-input>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-960.pvd-field-group--vertical-align-center>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-960.pvd-field-group--vertical-align-bottom>.apex3-text-input{align-items:flex-end}}@media (min-width:80em){.pvd-field-group--inline-at-1280>.pvd-field-group__field-group>s-slot>s-assigned-wrapper{align-items:flex-start;display:flex;flex-flow:row nowrap}.pvd-field-group--inline-at-1280>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-1280>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-1280>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input,.pvd-field-group--inline-at-1280>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-1280>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{flex:1 1 100%}.pvd-field-group--inline-at-1280.pvd-field-group--vertical-align-center>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-1280.pvd-field-group--vertical-align-bottom>.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input{align-items:flex-end}.pvd-field-group--inline-at-1280>.apex3-text-input{align-items:flex-start;display:flex;flex:1 1 100%;flex-flow:row nowrap}.pvd-field-group--inline-at-1280>.apex3-text-input>.apex3-text-input{margin-left:1.5rem;min-width:0}.pvd-field-group--inline-at-1280>.apex3-text-input>.apex3-text-input:first-child{margin-left:0}.pvd-field-group--inline-at-1280>.apex3-text-input>.apex3-text-input,.pvd-field-group--inline-at-1280>.apex3-text-input>.apex3-text-input+.apex3-text-input{margin-top:0}.pvd-field-group--inline-at-1280.pvd-field-group--vertical-align-center>.apex3-text-input{align-items:center}.pvd-field-group--inline-at-1280.pvd-field-group--vertical-align-bottom>.apex3-text-input{align-items:flex-end}}.pvd-field-group__field-group>.apex3-text-input+.apex3-text-input,.pvd-field-group__field-group>s-slot>s-assigned-wrapper>.apex3-text-input+.apex3-text-input{margin-top:2.5rem}";
styleInject(css_248z);

class ApexTextInputComponent extends ApexValidatableBaseComponent {
    constructor() {
        super(...arguments);
        //#endregion
        //#region PROPERTIES
        this._value = '';
        this.label = CommonContent.apexTextInput.fields.textInput.label;
        this.optionalLabel = '(optional)';
        this._validationRules = {
            validations: {
                required: false,
                min: 0,
                max: 128,
                regex: '(.*?)' // allow everything
            }
        };
        this.dataPii = true;
        this.inputType = 'text';
        this._validationText = {
            validations: {
                required: CommonContent.apexTextInput.fields.textInput.errorMessages.isRequired,
                min: CommonContent.apexTextInput.fields.textInput.errorMessages.minLength,
                max: CommonContent.apexTextInput.fields.textInput.errorMessages.maxLength,
                regex: CommonContent.apexTextInput.fields.textInput.errorMessages.fieldRegex,
                // @ts-ignore
                validValues: CommonContent.apexTextInput.fields.textInput.errorMessages.validValues,
                // @ts-ignore
                invalidValues: CommonContent.apexTextInput.fields.textInput.errorMessages.invalidValues
            }
        };
        this.readonly = false;
        this.supplementalText = '';
        this.hasInlineAccessoryActions = false;
        this.maskRegex = '';
        this.maskPattern = '';
        this.leadingIcon = '';
        this.trailingIcon = '';
        this.textAlign = 'left';
        this.nested = false;
        this.enableShowRequired = false;
        this.enableShowOptional = false;
        this.disableBrowserAutocomplete = false;
        this.formattedValue = '';
        this.inputMode = 'text';
        this.isDirty = false;
        //#endregion
    }
    //#region LIFE CYCLE HOOKS
    connectedCallback() {
        super.connectedCallback();
        // @ts-ignore
        window.ApexEventBus.addEventListener('apexValidate', this.validationEventHandler.bind(this));
    }
    disconnectedCallback() {
        // @ts-ignore
        window.ApexEventBus.removeEventListener('apexValidate', this.validationEventHandler);
        super.disconnectedCallback();
    }
    validationEventHandler() {
        this.checkValidity();
    }
    checkValidity(suppressErrors = false) {
        // don't show any error messages or anything for read only values
        if (this.readonly) {
            return;
        }
        this.triggerFormatValue();
        // @ts-ignore
        this.validate(suppressErrors);
    }
    // because the current Providence formatter works on an event object, we need to fake one to trigger formatting
    // @TODO contribute back additional formatters to PVD2 that don't require events
    triggerFormatValue() {
        const tempInput = document.createElement('input');
        tempInput.value = this.value;
        tempInput.addEventListener('init-value', (e) => {
            this.formatValue(e);
            this.value = e.target.value;
        });
        const tempEvent = new Event('init-value');
        tempInput.dispatchEvent(tempEvent);
    }
    firstUpdated() {
        this.classList.add('apex3-text-input');
        Object.keys(this._validationRules.validations).forEach(rule => this.updateValidationRule(rule));
    }
    //#endregion
    //#region RENDER
    render() {
        const { 
        // @ts-ignore
        idPrefix, value, label, optionalLabel, readonly, dataPii, supplementalText, inputType, leadingIcon, trailingIcon, textAlign, nested, enableShowRequired, enableShowOptional, disableBrowserAutocomplete, errorMessage, inputMode } = this;
        let { formattedValue } = this;
        // @ts-ignore
        const { pvdNamespace } = this.constructor;
        if (!formattedValue) {
            formattedValue = value;
        }
        let supplementalTextHtml = html ``;
        if (supplementalText.trim() !== '') {
            supplementalTextHtml = html `
        <div class="${pvdNamespace}-microcopy-root" id="${idPrefix}-micro">
          <p class="pvd-microcopy__microcopy">${supplementalText}</p>
        </div>
      `;
        }
        const labelClass = nested ? 'pvd-label--secondary' : 'pvd-label--primary';
        if (readonly) {
            return html `
        <div class="${pvdNamespace}-field-group-root pvd-field-group--full-width pvd-field-group--vertical-align-top">
          <div class="pvd-field-group__field-group">
            <div class="${pvdNamespace}-label-root pvd-label--medium ${labelClass} apex3-text-input-label">
              <div class="pvd-label__label">${label}</div>
              <s-slot></s-slot>
              <s-slot name="inline-readonly-accessory"></s-slot>
            </div>
            ${supplementalTextHtml}
            <p class="pvd-field-group__display-data" data-pii=${dataPii}>
              ${leadingIcon ? html `<span id="${idPrefix}-readonly-leading-icon">${leadingIcon}</span>` : ''}${this.mask(formattedValue)}${trailingIcon ? html `<span id="${idPrefix}-readonly-trailing-icon">${trailingIcon}</span>` : ''}
            </p>
            <s-slot class="hide-element" name="inline-accessory-actions"></s-slot>
          </div>
        </div>
      `;
        }
        let ariaDescribedby = '';
        if (supplementalText) {
            ariaDescribedby = `${idPrefix}-micro`;
        }
        let glyphClass = '';
        if (leadingIcon) {
            glyphClass = 'pvd-input--icon-left';
        }
        if (trailingIcon) {
            glyphClass = 'pvd-input--icon-right';
        }
        return html `
      <div class="${pvdNamespace}-field-group-root pvd-field-group--full-width pvd-field-group--vertical-align-top">
        <div class="pvd-field-group__field-group">
          <div class="${pvdNamespace}-label-root pvd-label--medium ${labelClass} apex3-text-input-label">
            <label class="pvd-label__label" for="${idPrefix}-input">
              ${label}${this.validationRules.validations.required && enableShowRequired
            ? html `<span aria-hidden="true" class="pvd-label__indicator pvd-label__indicator--required">*</span>`
            : ''}${enableShowOptional && (optionalLabel === null || optionalLabel === void 0 ? void 0 : optionalLabel.length)
            ? html `<span class="pvd-label__indicator">${optionalLabel}</span>`
            : ''}
            </label>
            <s-slot></s-slot>
            <s-slot class="hide-element" name="inline-readonly-accessory"></s-slot>
          </div>
          ${supplementalTextHtml}
          <div
            class="${pvdNamespace}-field-group-root pvd-field-group--dense pvd-field-group--full-width pvd-field-group--inline-at-512  pvd-field-group--vertical-align-top"
          >
            <div class="pvd-field-group__field-group">
              <div
                class="${pvdNamespace}-field-group-root pvd-field-group--full-width pvd-field-group--vertical-align-top"
              >
                <div class="pvd-field-group__field-group">
                  <div
                    id="${idPrefix}-input-container"
                    class="${pvdNamespace}-input-root ${glyphClass} pvd-input--medium pvd-input--text-${textAlign} apex3-pvd3-input-root"
                  >
                    ${leadingIcon
            ? html `
                          <span class="pvd-input__icon pvd-input__icon--left">
                            <span id="${idPrefix}-leading-icon" slot="icon-left">${leadingIcon}</span>
                          </span>
                        `
            : ''}<input
                      id="${idPrefix}-input"
                      value="${formattedValue}"
                      type="${inputType}"
                      inputmode="${inputMode}"
                      minlength="${this.validationRules.validations.min}"
                      maxlength="${this.validationRules.validations.max}"
                      data-pii="${dataPii}"
                      @change="${this.handleChange}"
                      @focus="${(e) => this.restoreValue(e)}"
                      @input="${(e) => this.handleInput(e)}"
                      @keypress="${(e) => this.formatValue(e)}"
                      @blur="${(e) => this.revalidate(e)}"
                      class="pvd-input__input"
                      aria-describedby="${ariaDescribedby}"
                      autocomplete="${disableBrowserAutocomplete ? 'off' : 'on'}"
                    />${trailingIcon
            ? html `
                          <span class="pvd-input__icon pvd-input__icon--right">
                            <span id="${idPrefix}-trailing-icon" slot="icon-right">${trailingIcon}</span>
                          </span>
                        `
            : ''}
                  </div>
                </div>
              </div>
              <div class="apex3-text-input-actions${!this.hasInlineAccessoryActions ? ' hide-element' : ''}">
                <s-slot name="inline-accessory-actions"></s-slot>
              </div>
            </div>
            <div
              id="${idPrefix}-errors"
              class="${pvdNamespace}-inline-alert-root pvd-inline-alert--critical pvd-inline-alert--medium hide-element apex3-error-message"
            >
              <div class="pvd-inline-alert__icon">
                <svg aria-hidden="true" class="${pvdNamespace}-icon-root pvd-icon--small" focusable="false">
                  <use href="#${pvdNamespace}-alert__critical" xlink:href="#${pvdNamespace}-alert__critical"></use>
                </svg>
              </div>
              <div class="pvd-inline-alert__content">
                <span class="pvd-inline-alert__content-a11y-text">critical</span>
                <span id="${idPrefix}-error">${errorMessage}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    get value() {
        return this._value;
    }
    set value(newValue) {
        const oldValue = this.value;
        // we need to ensure that we don't set the component as dirty on the initialization of value
        // and don't unset it once it is set to true
        if (!this.isDirty && newValue !== '') {
            this.isDirty = oldValue !== newValue;
        }
        this._value = newValue;
        // we want to avoid a continuous loop dispatch which can happen sometimes with bound values
        if (newValue !== oldValue) {
            // @ts-ignore
            this.requestUpdate('value', oldValue);
            this.dispatchUpdateEvent();
        }
    }
    get validatableValue() {
        return this.value;
    }
    get validationRules() {
        return this._validationRules;
    }
    set validationRules(newRules) {
        const oldValue = this.validationRules;
        this._validationRules.validations = Object.assign(Object.assign({}, this._validationRules.validations), newRules.validations);
        // @ts-ignore
        Object.keys(newRules.validations).forEach(rule => this.updateValidationRule(rule));
        // @ts-ignore
        this.requestUpdate('validationRules', oldValue);
    }
    get validationText() {
        return this._validationText;
    }
    set validationText(newText) {
        const oldValue = this.validationText;
        this._validationText.validations = Object.assign(Object.assign({}, this._validationText.validations), newText.validations);
        // @ts-ignore
        Object.keys(newText.validations).forEach(rule => this.updateValidationRule(rule));
        // @ts-ignore
        this.requestUpdate('validationText', oldValue);
    }
    get leftGlyph() {
        return this.leadingIcon;
    }
    get rightGlyph() {
        return this.trailingIcon;
    }
    get optional() {
        return this.enableShowOptional;
    }
    get valid() {
        return this._valid;
    }
    set valid(newValue) {
        const oldValue = this.valid;
        this._valid = newValue;
        this.requestUpdate('valid', oldValue);
    }
    //#endregion
    //#region METHODS
    handleChange(event) {
        const value = event.target.value.trim();
        this.validate();
        this.value = value;
        this.dispatchUpdateEvent();
    }
    handleInput(event) {
        if (event && event.target) {
            this.value = event.target.value.trim();
            this.dispatchUpdateEvent();
        }
    }
    revalidate(event) {
        if (event && event.target) {
            const startingValue = event.target.value.trim();
            this.formatValue(event);
            const value = event.target.value.trim();
            if (startingValue !== value) {
                this.value = value;
                this.dispatchUpdateEvent();
            }
            if (value.length > 1) {
                this.validate();
            }
        }
    }
    dispatchUpdateEvent() {
        this.dispatchEvent(new CustomEvent('value-changed', {
            bubbles: true,
            composed: true,
            detail: {
                value: this.value,
                formattedValue: this.formattedValue,
                valid: this.valid
            }
        }));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    restoreValue(e) {
        // intentianlly left blank
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formatValue(event) {
        // intentionally left empty as it will be overridden by child components as necessary
    }
    mask(value) {
        if (value && this.maskRegex && this.maskPattern) {
            return value.replace(new RegExp(this.maskRegex, 'g'), this.maskPattern);
        }
        return value;
    }
    updateErrorMessageDisplay() {
        var _a, _b;
        // @ts-ignore
        const { idPrefix } = this;
        // @ts-ignore
        const { pvdNamespace } = this.constructor;
        const errorMessageContainer = this.querySelector(`#${idPrefix}-errors`);
        const textInput = this.querySelector(`#${idPrefix}-input`);
        const oldErrorMessage = this.errorMessage;
        this.errorMessage = this.valid ? '' : this.errorMessage;
        let describedby = ((_a = textInput.getAttribute('aria-describedby')) === null || _a === void 0 ? void 0 : _a.split(' ')) || [];
        if (this.valid) {
            textInput.setAttribute('aria-invalid', 'false');
            describedby = describedby.filter(a => a !== `${idPrefix}-errors`);
        }
        else {
            textInput.setAttribute('aria-invalid', 'true');
            describedby = describedby.filter(a => a !== '' && a !== `${idPrefix}-errors`);
            describedby.unshift(`${idPrefix}-errors`);
        }
        textInput.setAttribute('aria-describedby', describedby.join(' '));
        (_b = textInput.closest(`.${pvdNamespace}-input-root`)) === null || _b === void 0 ? void 0 : _b.classList[this.valid ? 'remove' : 'add']('pvd-input--error');
        errorMessageContainer.classList[this.valid ? 'add' : 'remove']('hide-element');
        this.requestUpdate('errorMessage', oldErrorMessage);
    }
}
ApexTextInputComponent.version = version;
__decorate([
    n$1({ type: String, attribute: 'value', reflect: true }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ApexTextInputComponent.prototype, "value", null);
__decorate([
    n$1({ type: String, attribute: 'label' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "label", void 0);
__decorate([
    n$1({ type: String, attribute: 'optional-label' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "optionalLabel", void 0);
__decorate([
    n$1({ type: Object, attribute: 'validation-rules' }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ApexTextInputComponent.prototype, "validationRules", null);
__decorate([
    n$1({
        type: Boolean,
        attribute: 'data-pii',
        reflect: true,
        converter: (value) => {
            if (value === 'true') {
                return true;
            }
            return false;
        }
    }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "dataPii", void 0);
__decorate([
    n$1({
        type: String,
        attribute: 'input-type',
        reflect: true,
        converter: (value) => {
            if (value) {
                return value.toLowerCase();
            }
            return '';
        }
    }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "inputType", void 0);
__decorate([
    n$1({ type: Object, attribute: 'validation-text' }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ApexTextInputComponent.prototype, "validationText", null);
__decorate([
    n$1({ type: Boolean, attribute: 'readonly' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "readonly", void 0);
__decorate([
    n$1({ type: String, attribute: 'supplemental-text' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "supplementalText", void 0);
__decorate([
    n$1({ type: Boolean, attribute: 'has-inline-accessory-actions' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "hasInlineAccessoryActions", void 0);
__decorate([
    n$1({ type: String, attribute: 'mask-regex' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "maskRegex", void 0);
__decorate([
    n$1({ type: String, attribute: 'mask-pattern' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "maskPattern", void 0);
__decorate([
    n$1({ type: String, attribute: 'leading-icon' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "leadingIcon", void 0);
__decorate([
    deprecatePropertyTo({ newPropertyKey: 'leadingIcon' }),
    n$1({ type: String, attribute: 'leftGlyph' }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ApexTextInputComponent.prototype, "leftGlyph", null);
__decorate([
    n$1({ type: String, attribute: 'trailing-icon' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "trailingIcon", void 0);
__decorate([
    deprecatePropertyTo({ newPropertyKey: 'trailingIcon' }),
    n$1({ type: String, attribute: 'right-glyph' }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ApexTextInputComponent.prototype, "rightGlyph", null);
__decorate([
    n$1({ type: String, attribute: 'text-align' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "textAlign", void 0);
__decorate([
    n$1({ type: Boolean }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "nested", void 0);
__decorate([
    n$1({ type: Boolean, attribute: 'enable-show-required' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "enableShowRequired", void 0);
__decorate([
    n$1({ type: Boolean, attribute: 'enable-show-optional' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "enableShowOptional", void 0);
__decorate([
    deprecatePropertyTo({ newPropertyKey: 'enableShowOptional' }),
    n$1({ type: Boolean, attribute: 'mark-optional' }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], ApexTextInputComponent.prototype, "optional", null);
__decorate([
    n$1({ type: Boolean, attribute: 'disable-browser-autocomplete' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "disableBrowserAutocomplete", void 0);
__decorate([
    n$1({ type: String, attribute: 'input-mode' }),
    __metadata("design:type", Object)
], ApexTextInputComponent.prototype, "inputMode", void 0);
const ApexCustomElementMixin = apexCustomElement({
    namespace: 'apex',
    shadowDOM: false,
    name: 'text-input',
    pvdNamespace: 'pvd'
});
class ApexTextInput extends ApexSlotableMixin(ApexCustomElementMixin(ApexTextInputComponent)) {
}

export { ApexTextInput, ApexTextInputComponent };
//# sourceMappingURL=component.js.map
